import { appTranslations } from "@translations/translations.app";

const PWA_DOMAIN_PREFIX = "batmaid_pwa_";
const AGENT_DOMAIN_PREFIX = "batmaid_pwa_agent_";

// The only hand-maintained list: non-agent-prefixed domains the agent app
// also needs
const AGENT_APP_SHARED_DOMAINS = [
  "batmaid_pwa_generic",
  "batmaid_pwa_navigation",
  "batmaid_pwa_apply",
  "batmaid_pwa_b2b",
  "batmaid_pwa_profile",
  "batmaid_pwa_rating",
];

/**
 * Splits translation domains (the files in @translations/app) into per-app
 * lists: `batmaid_pwa_agent_*` belongs to the agent app, every other
 * `batmaid_pwa_*` domain to the client app, and anything else falls into
 * `other` — not registered in any app, which is most likely a mistake
 * (@scripts/preloadTranslations.ts warns about such domains).
 */
export const deriveTranslationDomains = (
  allDomains: string[],
): Record<"app" | "agentApp" | "other", string[]> => {
  const agentDomains = allDomains.filter(domain =>
    domain.startsWith(AGENT_DOMAIN_PREFIX),
  );

  return {
    app: allDomains.filter(
      domain =>
        domain.startsWith(PWA_DOMAIN_PREFIX) &&
        !domain.startsWith(AGENT_DOMAIN_PREFIX),
    ),
    agentApp: [...agentDomains, ...AGENT_APP_SHARED_DOMAINS],
    other: allDomains.filter(domain => !domain.startsWith(PWA_DOMAIN_PREFIX)),
  };
};

export const translationDomains = deriveTranslationDomains(
  Object.keys(appTranslations),
);
